import { Grid, Select, styled, SxProps } from "@mui/material";
import { DataGridPremium, gridClasses } from "@mui/x-data-grid-premium";

export const wrapperMixin: SxProps = {
  mb: 2,
};

export const StyledGrid = styled(Grid)(({ theme }) => ({
  margin: theme.spacing(0, -2),
})) as typeof Grid;

export const StyledSelect = styled(Select)(({ theme }) => ({
  margin: theme.spacing(0, 1),
})) as unknown as typeof Select;

export const StyledDataGridPremium = styled(DataGridPremium)(({ theme }) => ({
  [`& .${gridClasses.cell}`]: {
    padding: theme.spacing(1.5),
  },
  [`& .${gridClasses["row--detailPanelExpanded"]} .${gridClasses.cell}`]: {
    borderBottom: "none",
  },
})) as typeof DataGridPremium;
